import React, { useEffect, useState } from 'react';
import { Button, Form, Row, Spinner } from 'react-bootstrap';
import AutocompleteSelect from '../../../shared/components/AutocompleteSelect';
import { CampaignsService } from '../../campaigns/CampaignsService';
import { Campaign } from '../../../model/campaign/Campaign';
import { useSelector } from 'react-redux';
import { downloadFileRequest } from '../../../api/services';
import { LIST_OFFER_URL } from '../../../utils/Endpoints';
import { getCorrectEnums } from '../../../utils/Functions';
import SingleSelectDropdown, { toSelectValue } from '../../../shared/components/SingleSelectDropdown';
import CardLayout from '../../../shared/components/CardLayout';
import { ErrorToast } from '../../../utils/toasters';

export interface IExportParams {
    campaignId: number | undefined;
    status: string;
}

export default function ExportOffers() {
    const [campaignId, setCampaignId] = useState(undefined);
    const [campaign, setCampaign] = useState<Campaign[]>([]);
    const [status, setStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { offerStatus } = useSelector((state: any) => state.enums);

    useEffect(() => {
        const getCampaigns = async () => {
            try {
                const { data } = await CampaignsService.getCampaigns({ perPage: 10000, isLongTerm: false });
                setCampaign(data);
            } catch (error) {
                ErrorToast(error);
            }
        };
        getCampaigns();
    }, []);

    const doExport = async () => {
        try {
            downloadFileRequest(
                `${LIST_OFFER_URL}/export/period`,
                'xlsx',
                null,
                { campaignId: campaignId, status: status },
                setIsLoading
            );
        } catch (error) {
            ErrorToast(error);
        }
    };

    return (
        <CardLayout classCard="mb-5" classBody="p-4">
            <Form>
                <Row>
                    <div className="form-group col-md col-sm-12">
                        <AutocompleteSelect
                            className="autocomplete-input"
                            list={campaign}
                            listKey={'title'}
                            updateState={setCampaignId}
                            placeholder={'Campaign'}
                        />
                    </div>
                    <div className="form-group col-md col-sm-12">
                        <SingleSelectDropdown
                            placeholder="All statuses"
                            options={(offerStatus ?? []).map((item: string) => ({
                                value: item,
                                label: getCorrectEnums(item),
                            }))}
                            selected={toSelectValue(status)}
                            onChange={setStatus}
                        />
                    </div>
                </Row>
                <Button disabled={isLoading} className="mt-4" onClick={() => doExport()}>
                    {isLoading ? (
                        <>
                            Downloading excel... <Spinner animation="border" size="sm" role="status" className="ml-1" />
                        </>
                    ) : (
                        'Export'
                    )}
                </Button>
            </Form>
        </CardLayout>
    );
}
